export default "__VITE_ASSET__iSf3$Kly__"